import { ensureTokenUrl } from '@src/model/config/helpers';
import { getFlairNameById } from '@src/model/token/helpers';
import { usePost } from '@src/store/posts/hooks/usePost';
import type { FC } from 'react';
import { Fragment, memo } from 'react';
import { Link } from 'react-router';

interface PostFlairsProps {
    postId: string;
    tokenName: string;
}

const PostFlairs: FC<PostFlairsProps> = ({ postId, tokenName }) => {
    const post = usePost(postId);
    const flairIds = post?.flairIds || [];

    if (flairIds.length === 0) return null;

    return (
        <div className="flex flex-wrap items-center gap-1 text-xs italic text-gray-500">
            {flairIds.map((flairId, index) => {
                const flairName = getFlairNameById(flairId, tokenName);
                if (!flairName) return null;

                return (
                    <Fragment key={flairId}>
                        {index > 0 && <span>•</span>}
                        <Link to={`/${ensureTokenUrl(tokenName)}/${flairId}`} className="hover:text-gray-700 hover:underline">
                            {flairName}
                        </Link>
                    </Fragment>
                );
            })}
        </div>
    );
};

export default memo(PostFlairs);
